import { createReducer } from "reduxsauce"
import { omit } from "lodash"
import { takeLatest, select, put } from "redux-saga/effects"
import actionCreator from "helpers/actionCreator"
import { Types as BaseTypes } from "modules/portfolio-root/model"
import { getCategoryItemsSubset } from "./selectors/data"

export const { Types, Creators } = actionCreator("ompnt/modules/analyzeForecast", {
  toggle: {
    props: ["id", "currentState"],
    track: true,
    trackType: "analyze-forecast-graph-legend-factor",
    trackPayload: ({ id, currentState }) => ({ factor: id, state: currentState ? "on" : "off" }),
  },
  focusChartLine: ["focusedChartLine"],
  blurChartLine: [],
  setDisplayType: {
    props: ["displayType"],
    track: true,
    trackType: "analyze-forecast-category-selection",
    trackPayload: ({ displayType }) => ({ type: displayType }),
  },
  trackCSVDownload: {
    track: true,
    trackType: "analyze-forecast-graph-timeseries-download",
  },
  toggleOnly: {
    props: ["id", "contentSetId"],
    track: true,
    trackType: "analyze-forecast-graph-legend-factor",
    trackPayload: ({ id, contentSetId }) => ({ factor: id, contentSetId }),
  },
  toggleOnlySuccess: ["selected", "only", "items"],
})

const DEFAULT_STATE = {
  displayType: "expectedReturn",
  focusedChartLine: null,
  contributorsDetailsVisible: false,
  selectedContributor: null,
  disabled: {},
  only: null,
}

function handleSetDisplayType(state, { displayType }) {
  return { ...state, displayType, only: null }
}

function handleToggle(state, { id }) {
  let disabled
  let focusedChartLine

  if (state.disabled[id]) {
    focusedChartLine = id
    disabled = omit(state.disabled, id)
  } else {
    focusedChartLine = null
    disabled = { [id]: true, ...state.disabled }
  }
  return { ...state, disabled, focusedChartLine, only: null }
}

function handleFocusChartLine(state, { focusedChartLine }) {
  return { ...state, focusedChartLine }
}

function handleBlurChartLine(state) {
  return { ...state, focusedChartLine: null }
}

function handleToggleOnlySuccess(state, { selected, only, items }) {
  const disabled = {}
  let focusedChartLine = null
  let onlyDisplay = null

  if (only) {
    focusedChartLine = selected
    onlyDisplay = selected
    items.forEach(item => {
      if (item.id !== selected) {
        disabled[item.id] = true
      }
    })
  }

  return { ...state, disabled, focusedChartLine, only: onlyDisplay }
}

function handleSetModel(state) {
  return { ...state, only: null, focusedChartLine: null }
}

export default createReducer(DEFAULT_STATE, {
  [Types.TOGGLE]: handleToggle,
  [Types.FOCUS_CHART_LINE]: handleFocusChartLine,
  [Types.BLUR_CHART_LINE]: handleBlurChartLine,
  [Types.SET_DISPLAY_TYPE]: handleSetDisplayType,
  [Types.TOGGLE_ONLY_SUCCESS]: handleToggleOnlySuccess,
  [BaseTypes.SET_MODEL]: handleSetModel,
})

function* handleToggleOnly({ id, contentSetId }) {
  const { items, only } = yield select(state => ({
    items: getCategoryItemsSubset(state, { contentSetId }),
    only: state.modules.analyzeForecast.only,
  }))

  yield put(Creators.toggleOnlySuccess(id, only !== id, items))
}

export function* saga() {
  yield takeLatest(Types.TOGGLE_ONLY, handleToggleOnly)
}
